// src/pages/Users/UserManage.jsx
import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Select, Spin, Tag, Space, Tooltip, Drawer, Typography, Flex, Grid } from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  MailOutlined,
  RedoOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons";
import Swal from "sweetalert2";

import {
  getBranchApi,
  getUserApi,
  getUserDisableRestoreApi,
  userEmailSentApi,
  signUpApi,
  userUpdateApi,
  getUserRoleSubscriptionWiseListApi,
} from "../../../apiservice/setting";
import { getAccessType, Trial_Limits } from "../../../lib/functions";
import { useIsAdminUser } from "../../../lib/accessList";
import { Checkbox } from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;
const { Title } = Typography;

const UserManage = ({ authInfo }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [users, setUsers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [subBranches, setSubBranches] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [access_type, access_type_set] = useState("");
  console.log(users, "users");
  const userCount = users.filter(user => user.acc_type !== "employee").length;

  console.log(userCount, "userCount");

  const [modalOpen, setModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [formValues, setFormValues] = useState({
    full_name: "",
    email: "",
    name: "",
    selectedBranch: null,
    selectedSubBranch: [],
    selectedUserRole: [],
    can_edit: false,
    can_delete: false,
    action: "create",
    id: 0,
  });
  const [helpOpen, setHelpOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const isAdminUser = useIsAdminUser();


  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;



  useEffect(() => {
    const access = getAccessType("user_entry");
    access_type_set(access);
  }, []);

  // ✅ Load branches, roles, users
  useEffect(() => {
    loadBranches();
    loadRoles();
    loadUsers();
  }, []);

  // ✅ Update subBranches when primary branch changes
  useEffect(() => {
    if (formValues.selectedBranch) {
      const filtered = branches
        .filter((b) => b.id !== formValues.selectedBranch.id)
        .map((b) => ({
          value: b.id,
          label: b.name,
        }));
      setSubBranches(filtered);
    } else {
      setSubBranches([]);
    }
  }, [formValues.selectedBranch, branches]);

  const loadBranches = async () => {
    try {
      const res = await getBranchApi({ "select-type": "active" });
      setBranches(res.data.message || []);
    } catch (err) {
      Swal.fire("Error", "Failed to fetch branches", "error");
    }
  };

  const loadRoles = async () => {
    try {
      const res = await getUserRoleSubscriptionWiseListApi({
        id: authInfo.subscription_id,
        institution_id: authInfo.id,
      });

      const subscriptionBaseData = res.data.subscriptionBaseData;
      const userAddedRoles = res.data.userAddedRoles;

      const mergedRoles = [...subscriptionBaseData, ...userAddedRoles];
      // const formatted = mergedRoles.map((role) => {
      //   const label = role.role_name.includes("_")
      //     ? role.role_name.split("_").slice(2).join(" ")
      //     : role.role_name;
      //   return {
      //     value: role.id,
      //     label,
      //   };
      // });
      const formatted = mergedRoles.map((role) => {
      const parts = role.role_name.split("_");

      let label = role.role_name;

      // subscription roles like ForthERP_Pro_admin
      if (parts.length > 2) {
        label = parts.slice(2).join(" ");
      }

      return {
        value: role.id,
        label,
      };
    });
      setRoles(formatted);
    } catch (err) {
      Swal.fire("Error", "Failed to fetch roles", "error");
    }
  };

  const loadUsers = async () => {
    setLoading(true);
    try {
      const res = await getUserApi({ "select-type": "active" });
      const userdatamodified = res.data.message.map((item) => {
        const roleLabels = item.user_roles
          ? [
            ...new Set(
              item.user_roles.split(",").map((role) => {
                const parts = role.split("_");
                const formatted =
                  parts.length > 2
                    ? parts.slice(2).join(" ")
                    : role;
                return formatted
                  .split(" ")
                  .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                  .join(" ");
              })
            ),
          ] // ✅ removes duplicates
          : [];

        return {
          ...item,
          roleLabels, // ✅ clean display labels
          roleIds: [...new Set(item.user_role_id?.split(",") || [])], // ✅ store clean IDs
        };
      });
      setUsers(userdatamodified);
    } catch (err) {
      Swal.fire("Error", "Failed to fetch users", "error");
    }
    setLoading(false);
  };

  // ✅ Save new / edit
  const handleSave = async () => {
    try {
      // --- VALIDATION ---
      const validationMessages = {
        full_name: "Full Name is required!",
        email: "Email is required!",
        name: "User Name is required!",
        selectedBranch: "Branch is required!",
        selectedUserRole: "Role is required!",
      };

      const maxLengths = {
        full_name: 100,
        email: 40,
        name: 50,
      };

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (authInfo?.trial_mode == "yes") {
        const userName = authInfo?.userInfo?.name || "User";

        Swal.fire({
          icon: "warning",
          title: `Hi ${userName}!`,
          text: "You are currently using the Free version. Please upgrade your plan.",
        });

        return;
      }

      for (const [key, message] of Object.entries(validationMessages)) {
        const value = formValues[key];

        if (
          !value ||
          (typeof value === "string" && value.trim() === "") ||
          (typeof value === "object" &&
            value !== null &&
            Object.keys(value).length === 0)
        ) {
          Swal.fire("Warning", message, "warning");
          return;
        }

        if (key === "email" && !emailPattern.test(value)) {
          Swal.fire("Warning", "Invalid email address", "warning");
          return;
        }

        if (
          typeof value === "string" &&
          maxLengths[key] &&
          value.length > maxLengths[key]
        ) {
          Swal.fire(
            "Warning",
            `${key.replace("_", " ")} cannot exceed ${maxLengths[key]
            } characters.`,
            "warning"
          );
          return;
        }
      }

      // 🚫 Prevent selecting main branch as secondary
      if (
        formValues.selectedBranch &&
        formValues.selectedSubBranch?.some(
          (b) => b.value === formValues.selectedBranch.id
        )
      ) {
        Swal.fire(
          "Warning",
          "Primary branch cannot be added as a secondary branch.",
          "warning"
        );
        return;
      }
      console.log(formValues, "formValues");

      // --- PAYLOAD MAPPING ---
      const payload = {
        full_name: formValues.full_name,
        email: formValues.email,
        name: formValues.name,
        selectedBranch: formValues.selectedBranch,
        selectedSubBranch: formValues.selectedSubBranch.map((b) => b.value),
        selectedUserRole: formValues.selectedUserRole.map((r) => ({
          value: r.value,
          label: r.label,
        })),

        can_edit: formValues.can_edit,
        can_delete: formValues.can_delete,

        action: isEdit ? "update" : "create",
        id: formValues.id || 0,
      };

      // --- API CALL ---
      let res;
      if (isEdit) {
        res = await userUpdateApi(payload);
      } else {
        res = await signUpApi(payload);
      }

      if (res.data.error) {
        Swal.fire("Warning", res.data.message, "warning");
      } else {
        Swal.fire("Success", res.data.message, "success");
        setModalOpen(false);
        resetForm();
        loadUsers();
      }
    } catch (err) {
      Swal.fire("Error", "Failed to save user", "error");
    }
  };

  // ✅ Reset form
  const resetForm = () => {
    setFormValues({
      full_name: "",
      email: "",
      name: "",
      selectedBranch: null,
      selectedSubBranch: [],
      selectedUserRole: [],
      can_edit: false,
      can_delete: false,
      action: "create",
      id: 0,
    });
    setIsEdit(false);
  };

  // ✅ Delete / Restore
  const handleDisableRestore = async (record) => {
    if (authInfo?.trial_mode == "yes") {
      const userName = authInfo?.userInfo?.name || "User";

      Swal.fire({
        icon: "warning",
        title: `Hi ${userName}!`,
        text: "You are currently using the Free version. Please upgrade your plan.",
      });

      return;
    }
    const action = record.status === "active" ? "disable" : "restore";
    Swal.fire({
      title: `Are you sure you want to ${action} this user?`,
      icon: "warning",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await getUserDisableRestoreApi({ id: record.id, action });
          Swal.fire("Success", `User ${action}d successfully`, "success");
          loadUsers();
        } catch (err) {
          Swal.fire("Error", "Failed to update user status", "error");
        }
      }
    });
  };

  // ✅ Resend password email
  const handleResendMail = async (record, index) => {

    try {
      const res = await userEmailSentApi({
        id: record.id,
        branch_id: record.branch_id,
        email: record.email,
        name: record.full_name || record.name,
        index,
      });

      const { error, message } = res.data;

      const failureMessages = [
        "Email sent failed",
        "SMTP not configured",
        "User email missing",
      ];

      if (error || failureMessages.includes(message)) {
        Swal.fire({
          title: message || "Failed to send email",
          icon: "error",
        });
      } else {
        Swal.fire({
          title: message || "Email sent successfully",
          icon: "success",
        });
      }
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: "Failed to resend mail",
        icon: "error",
      });
    }
  };

  // ✅ Edit handler
  const handleEdit = (record) => {
    const selectedRoles = record.roleIds
      .map((id) => {
        const role = roles.find((r) => r.value.toString() === id.toString());
        return role ? { value: role.value, label: role.label } : null;
      })
      .filter(Boolean);

    // ✅ Deduplicate sub-branches
    let empBranchIds = record.emp_branch_ids
      ? record.emp_branch_ids.split(",").map((id) => id)
      : [];
    empBranchIds = [
      ...new Set(empBranchIds.filter((id) => id !== record.branch_id)),
    ];

    const selectedSubBranch = empBranchIds
      .map((id) => {
        const branch = branches.find((b) => b.id === id);
        return branch ? { value: branch.id, label: branch.name } : null;
      })
      .filter(Boolean);

    const branchObj = branches.find((b) => b.id === record.branch_id);

    setFormValues({
      full_name: record.full_name,
      email: record.email,
      name: record.name,
      selectedBranch: branchObj
        ? { id: branchObj.id, name: branchObj.name }
        : null,
      selectedSubBranch,
      selectedUserRole: selectedRoles,
      can_edit: !!record.can_edit,
      can_delete: !!record.can_delete,
      id: record.id,
      action: "update",
    });

    setIsEdit(true);
    setModalOpen(true);
  };

  // const columns = [
  //   { title: "No.", render: (_, __, i) => i + 1 },
  //   { title: "Full Name", dataIndex: "full_name" },
  //   { title: "Email", dataIndex: "email" },
  //   { title: "Branch", dataIndex: "name" },
  //   {
  //     title: "Roles",
  //     dataIndex: "roleLabels",
  //     render: (labels, record) =>
  //       labels?.map((r, i) => <Tag key={`${record.id}-${i}`}>{r}</Tag>),
  //   },
  //   {
  //     title: "Account Type",
  //     dataIndex: "acc_type",
  //     render: (t) => (t ? t.charAt(0).toUpperCase() + t.slice(1) : "-"),
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     render: (s) =>
  //       s === "active" ? (
  //         <Tag color="green">Active</Tag>
  //       ) : (
  //         <Tag color="red">Disabled</Tag>
  //       ),
  //   },
  //   {
  //     title: "Actions",
  //     render: (_, record, index) => (
  //       <Space>
  //         <Button
  //           type="link"
  //           icon={<EditOutlined />}
  //           onClick={() => handleEdit(record, index)}
  //         />
  //         <Button
  //           type="link"
  //           icon={<MailOutlined />}
  //           onClick={() => handleResendMail(record, index)}
  //         />
  //         <Button
  //           type="link"
  //           icon={
  //             record.status === "active" ? <DeleteOutlined /> : <RedoOutlined />
  //           }
  //           danger={record.status === "active"}
  //           onClick={() => handleDisableRestore(record)}
  //         />
  //       </Space>
  //     ),
  //   },
  // ];

  const columns = [
    { title: "No.", render: (_, __, i) => i + 1 },
    { title: "Full Name", dataIndex: "full_name" },
    { title: "Email", dataIndex: "email" },
    { title: "Branch", dataIndex: "bname" },
    {
      title: "Roles",
      dataIndex: "roleLabels",
      render: (labels, record) =>
        labels?.map((r, i) => <Tag key={`${record.id}-${i}`}>{r}</Tag>),
    },
    {
      title: "Account Type",
      dataIndex: "acc_type",
      render: (t) => (t ? t.charAt(0).toUpperCase() + t.slice(1) : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (s) =>
        s === "active" ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Disabled</Tag>
        ),
    },

    ...(access_type === "WRITE"
      ? [
        {
          title: "Actions",
          render: (_, record, index) => (
            <Space>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record, index)}
                disabled={!(isAdminUser || canEdit)}
              />
              <Button
                type="link"
                icon={<MailOutlined />}
                onClick={() => handleResendMail(record, index)}
              />
              <Button
                type="link"
                disabled={!(isAdminUser || canDelete)}

                icon={
                  record.status === "active" ? (
                    <DeleteOutlined />
                  ) : (
                    <RedoOutlined />
                  )
                }
                danger={record.status === "active"}
                onClick={() => handleDisableRestore(record)}
              />
            </Space>
          ),
        },
      ]
      : []),
  ];

  return (
    <div>
      {access_type == "WRITE" && (
        <>
        <Flex
          justify="end"
          align="center"
          style={{ marginBottom: 16 }}
        >
          

          <Flex align="center" gap={6}>
            <Tooltip title="Help">
              <Button
                type="text"
                icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
                onClick={() => setHelpOpen(true)}
              />
            </Tooltip>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {

                if (authInfo?.trial_mode == "yes" && userCount >= Trial_Limits.user_count) {
                  const userName = authInfo?.userInfo?.name || "User";
                  Swal.fire({
                    icon: "warning",
                    title: `Hi ${userName}!`,
                    text: "You are currently using the Free version. Please upgrade your plan to add a new user.",
                  });
                  return;
                }

                resetForm();
                setModalOpen(true);
              }}
            >
              Add New
            </Button>
            
            </Flex>
          </Flex>
        </>
      )}
      
      <Drawer
        title="User Management Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={460}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}

      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: 18,
              fontWeight: 600,
              marginBottom: 12,
              marginLeft:12
            }}
          >
            User Management
          </h2>

          <p style={{ color: "#555", marginBottom: 16, marginLeft:17 }}>
            This section helps manage ERP users, branch assignments,
            user permissions, role access, and operational account controls.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: 14,
              borderRadius: 8,
              marginBottom: 16,
            }}
          >
            <strong>What You Can Do</strong>

            <ol style={{ paddingLeft: 20, marginTop: 10 }}>
              <li>Create new ERP users</li>
              <li>Edit user account details</li>
              <li>Assign primary and secondary branches</li>
              <li>Assign multiple user roles</li>
              <li>Enable edit and delete permissions</li>
              <li>Manage user operational access</li>
              <li>Disable or restore user accounts</li>
              <li>Resend account access emails</li>
              <li>Track active and disabled users</li>
              <li>Manage employee and system user accounts</li>
              <li>Control user access across ERP modules</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: 14,
              borderRadius: 8,
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: 18,
                marginTop: 10,
                color: "#666",
              }}
            >
              <li>Primary branches cannot be selected as secondary branches.</li>
              <li>Users can be assigned multiple ERP roles.</li>
              <li>Disabled users cannot access the ERP system.</li>
              <li>Permission settings affect edit and delete operations.</li>
              <li>Email addresses must be valid before saving users.</li>
              <li>Free version accounts have user creation limits.</li>
              <li>Only authorized users can manage user accounts.</li>
            </ul>
          </div>
        </div>
      </Drawer>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={users}
          rowKey="id"
          pagination={{
            ...pagination,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50"],
          }}
          onChange={handleTableChange}
          scroll={{ x: "max-content" }}
        />
      </Spin>

      <Modal
        open={modalOpen}
        title={isEdit ? "Edit User" : "Add User"}
        onCancel={() => {
          resetForm();
          setModalOpen(false);
        }}
        onOk={handleSave}
        width={700}
      >
        <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
          <div style={{ flex: 1, minWidth: 280 }}>
            <label>Full Name <span style={{ color: "#ff4d4f" }}>*</span></label>
            <Input
              value={formValues.full_name}
              onChange={(e) =>
                setFormValues({ ...formValues, full_name: e.target.value })
              }
              placeholder="Full Name"
            />
          </div>
          <div style={{ flex: 1, minWidth: 280 }}>
            <label>Email <span style={{ color: "#ff4d4f" }}>*</span></label>
            <Input
              type="email"
              value={formValues.email}
              onChange={(e) =>
                setFormValues({ ...formValues, email: e.target.value })
              }
              placeholder="Email"
            />
          </div>
          <div style={{ flex: 1, minWidth: 280 }}>
            <label>User Name <span style={{ color: "#ff4d4f" }}>*</span></label>
            <Input
              value={formValues.name}
              onChange={(e) =>
                setFormValues({ ...formValues, name: e.target.value })
              }
              placeholder="User Name"
            />
          </div>
          <div style={{ flex: 1, minWidth: 280 }}>
            <label>Branch <span style={{ color: "#ff4d4f" }}>*</span></label>
            <Select
              data-testid="branch-select"
              style={{ width: "100%" }}
              placeholder="Select Branch"
              value={formValues.selectedBranch?.id}
              onChange={(val) => {
                const branchObj = branches.find((b) => b.id === val);
                setFormValues({
                  ...formValues,
                  selectedBranch: branchObj
                    ? { id: branchObj.id, name: branchObj.name }
                    : null,
                  selectedSubBranch: [],
                });
              }}
            >
              {branches.map((b) => (
                <Option key={b.id} value={b.id}>
                  {b.name}
                </Option>
              ))}
            </Select>
          </div>

          {/* ✅ Secondary Branch Multi-Select */}
          <div style={{ flex: 1, minWidth: 280 }}>
            <label>Secondary Branches</label>
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              data-testid="secondary-branches-select"
              placeholder="Select Secondary Branches"
              value={formValues.selectedSubBranch?.map((b) => b.value)}
              onChange={(vals) => {
                const selected = vals
                  .map((id) => {
                    const branch = branches.find((b) => b.id === id);
                    return branch
                      ? { value: branch.id, label: branch.name }
                      : null;
                  })
                  .filter(Boolean);

                setFormValues({ ...formValues, selectedSubBranch: selected });
              }}
              maxTagCount="responsive"
              maxTagPlaceholder={(omittedValues) => (
                <span title={omittedValues.map((v) => v.label).join(", ")}>
                  +{omittedValues.length}
                </span>
              )}
            >
              {branches
                .filter((b) => b.id !== formValues.selectedBranch?.id)
                .map((b) => (
                  <Option key={b.id} value={b.id}>
                    {b.name}
                  </Option>
                ))}
            </Select>
          </div>

          <div style={{ flex: 1, minWidth: 280 }}>
            <label>Roles <span style={{ color: "#ff4d4f" }}>*</span></label>
            <Select
              data-testid="roles-select"
              mode="multiple"
              style={{ width: "100%" }}
              value={formValues.selectedUserRole?.map((r) => r.value)}
              onChange={(vals) =>
                setFormValues({
                  ...formValues,
                  selectedUserRole: vals.map((v) => ({
                    value: v,
                    label: roles.find((r) => r.value === v)?.label || "",
                  })),
                })
              }
              placeholder="Select Roles"
              maxTagCount="responsive"
              maxTagPlaceholder={(omittedValues) => (
                <span title={omittedValues.map((v) => v.label).join(", ")}>
                  +{omittedValues.length}
                </span>
              )}
            >
              {roles.map((r) => (
                <Option key={r.value} value={r.value}>
                  {r.label}
                </Option>
              ))}
            </Select>
          </div>

          <div style={{ flex: 1, minWidth: 280 }}>
            <label>Permissions</label>

            <div style={{ display: "flex", gap: 16, marginTop: 8 }}>
              <Checkbox
                checked={formValues.can_edit}
                onChange={(e) =>
                  setFormValues({ ...formValues, can_edit: e.target.checked })
                }
              >
                Allow Edit
              </Checkbox>

              <Checkbox
                checked={formValues.can_delete}
                onChange={(e) =>
                  setFormValues({ ...formValues, can_delete: e.target.checked })
                }
              >
                Allow Delete
              </Checkbox>
            </div>
          </div>


        </div>
      </Modal>
    </div>
  );
};

export default UserManage;
